export default __webpack_public_path__ + "static/media/Tags.361aba7d.svg";